const countryTranslations = {
  ad: "안도라",
  ae: "아랍에미리트",
  af: "아프가니스탄",
  ag: "앤티가 바부다",
  ai: "앵귈라",
  al: "알바니아",
  am: "아르메니아",
  ao: "앙골라",
  ar: "아르헨티나",
  as: "아메리칸 사모아",
  at: "오스트리아",
  au: "오스트레일리아",
  aw: "아루바",
  ax: "올란드 제도",
  az: "아제르바이잔",
  ba: "보스니아 헤르체고비나",
  bb: "바베이도스",
  bd: "방글라데시",
  be: "벨기에",
  bf: "부르키나파소",
  bg: "불가리아",
  bh: "바레인",
  bi: "부룬디",
  bj: "베냉",
  bl: "생바르텔레미",
  bm: "버뮤다",
  bn: "브루나이",
  bo: "볼리비아",
  bq: "네덜란드령 카리브",
  br: "브라질",
  bs: "바하마",
  bt: "부탄",
  bw: "보츠와나",
  by: "벨라루스",
  bz: "벨리즈",
  ca: "캐나다",
  cc: "코코스 제도",
  cd: "콩고-킨샤사",
  cf: "중앙 아프리카 공화국",
  cg: "콩고-브라자빌",
  ch: "스위스",
  ci: "코트디부아르",
  ck: "쿡 제도",
  cl: "칠레",
  cm: "카메룬",
  cn: "중국",
  co: "콜롬비아",
  cr: "코스타리카",
  cu: "쿠바",
  cv: "카보베르데",
  cw: "퀴라소",
  cx: "크리스마스섬",
  cy: "키프로스",
  cz: "체코",
  de: "독일",
  dj: "지부티",
  dk: "덴마크",
  dm: "도미니카",
  do: "도미니카 공화국",
  dz: "알제리",
  ec: "에콰도르",
  ee: "에스토니아",
  eg: "이집트",
  eh: "서사하라",
  er: "에리트리아",
  es: "스페인",
  et: "에티오피아",
  fi: "핀란드",
  fj: "피지",
  fk: "포클랜드 제도",
  fm: "미크로네시아",
  fo: "페로 제도",
  fr: "프랑스",
  ga: "가봉",
  gb: "영국",
  gd: "그레나다",
  ge: "조지아",
  gf: "프랑스령 기아나",
  gg: "건지",
  gh: "가나",
  gi: "지브롤터",
  gl: "그린란드",
  gm: "감비아",
  gn: "기니",
  gp: "과들루프",
  gq: "적도 기니",
  gr: "그리스",
  gt: "과테말라",
  gu: "괌",
  gw: "기니비사우",
  gy: "가이아나",
  hk: "홍콩(중국 특별행정구)",
  hn: "온두라스",
  hr: "크로아티아",
  ht: "아이티",
  hu: "헝가리",
  id: "인도네시아",
  ie: "아일랜드",
  il: "이스라엘",
  im: "맨 섬",
  in: "인도",
  io: "영국령 인도양 식민지",
  iq: "이라크",
  ir: "이란",
  is: "아이슬란드",
  it: "이탈리아",
  je: "저지",
  jm: "자메이카",
  jo: "요르단",
  jp: "일본",
  ke: "케냐",
  kg: "키르기스스탄",
  kh: "캄보디아",
  ki: "키리바시",
  km: "코모로",
  kn: "세인트키츠 네비스",
  kp: "북한",
  kr: "대한민국",
  kw: "쿠웨이트",
  ky: "케이맨 제도",
  kz: "카자흐스탄",
  la: "라오스",
  lb: "레바논",
  lc: "세인트루시아",
  li: "리히텐슈타인",
  lk: "스리랑카",
  lr: "라이베리아",
  ls: "레소토",
  lt: "리투아니아",
  lu: "룩셈부르크",
  lv: "라트비아",
  ly: "리비아",
  ma: "모로코",
  mc: "모나코",
  md: "몰도바",
  me: "몬테네그로",
  mf: "생마르탱",
  mg: "마다가스카르",
  mh: "마셜 제도",
  mk: "북마케도니아",
  ml: "말리",
  mm: "미얀마",
  mn: "몽골",
  mo: "마카오(중국 특별행정구)",
  mp: "북마리아나제도",
  mq: "마르티니크",
  mr: "모리타니",
  ms: "몬트세라트",
  mt: "몰타",
  mu: "모리셔스",
  mv: "몰디브",
  mw: "말라위",
  mx: "멕시코",
  my: "말레이시아",
  mz: "모잠비크",
  na: "나미비아",
  nc: "뉴칼레도니아",
  ne: "니제르",
  nf: "노퍽섬",
  ng: "나이지리아",
  ni: "니카라과",
  nl: "네덜란드",
  no: "노르웨이",
  np: "네팔",
  nr: "나우루",
  nu: "니우에",
  nz: "뉴질랜드",
  om: "오만",
  pa: "파나마",
  pe: "페루",
  pf: "프랑스령 폴리네시아",
  pg: "파푸아뉴기니",
  ph: "필리핀",
  pk: "파키스탄",
  pl: "폴란드",
  pm: "생피에르 미클롱",
  pr: "푸에르토리코",
  ps: "팔레스타인 지구",
  pt: "포르투갈",
  pw: "팔라우",
  py: "파라과이",
  qa: "카타르",
  re: "리유니온",
  ro: "루마니아",
  rs: "세르비아",
  ru: "러시아",
  rw: "르완다",
  sa: "사우디아라비아",
  sb: "솔로몬 제도",
  sc: "세이셸",
  sd: "수단",
  se: "스웨덴",
  sg: "싱가포르",
  sh: "세인트헬레나",
  si: "슬로베니아",
  sj: "스발바르제도-얀마웬섬",
  sk: "슬로바키아",
  sl: "시에라리온",
  sm: "산마리노",
  sn: "세네갈",
  so: "소말리아",
  sr: "수리남",
  ss: "남수단",
  st: "상투메 프린시페",
  sv: "엘살바도르",
  sx: "신트마르턴",
  sy: "시리아",
  sz: "에스와티니",
  tc: "터크스 케이커스 제도",
  td: "차드",
  tg: "토고",
  th: "태국",
  tj: "타지키스탄",
  tk: "토켈라우",
  tl: "동티모르",
  tm: "투르크메니스탄",
  tn: "튀니지",
  to: "통가",
  tr: "터키",
  tt: "트리니다드 토바고",
  tv: "투발루",
  tw: "대만",
  tz: "탄자니아",
  ua: "우크라이나",
  ug: "우간다",
  us: "미국",
  uy: "우루과이",
  uz: "우즈베키스탄",
  va: "바티칸 시국",
  vc: "세인트빈센트그레나딘",
  ve: "베네수엘라",
  vg: "영국령 버진아일랜드",
  vi: "미국령 버진아일랜드",
  vn: "베트남",
  vu: "바누아투",
  wf: "왈리스-푸투나 제도",
  ws: "사모아",
  ye: "예멘",
  yt: "마요트",
  za: "남아프리카",
  zm: "잠비아",
  zw: "짐바브웨"
};
export default countryTranslations;
